export const common = {
  actions: {
    back: 'Terug',
    bookmark: 'Bookmarken',
    cancel: 'Annuleren',
    clear: 'Wissen',
    close: 'Sluiten',
    copiedToClipboard: 'Gekopieerd naar klembord',
    copyToClipboard: 'Kopiëren naar klembord',
    create: 'Aanmaken',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    retry: 'Opnieuw proberen',
    revealPassword: 'Wachtwoord tonen',
    save: 'Opslaan',
    send: 'Versturen',
    openMenu: 'Open menu',
    moreInfo: 'Meer informatie',
  },
  pagination: {
    previous: 'Vorige pagina',
    next: 'Volgende pagina',
    label: 'Paginanavigatie',
    pageSize: 'Aantal resultaten per pagina',
  },
  navigation: {
    main: 'Hoofdnavigatie',
    menu: 'Menu',
    shortcuts: 'Snelnavigatie',
  },
  activities: {
    '1': {
      description: 'Grafisch ontwerp, Illustratie, Cartoon, Industrieel Design, Brand Design, Art Direction, 3D Art, ...',
      label: 'Visuele communicatie',
    },
    '10': {
      description: 'Social media',
      label: 'Online contentcreatie en storytelling',
    },
    '11': {
      label: 'Andere',
    },
    '2': {
      description: 'Webdesign, UI/UX, ...',
      label: 'Digitaal ontwerp',
    },
    '3': {
      description: 'Fotografie, postproductie, ...',
      label: 'Fotografie',
    },
    '4': {
      description: 'Videografie, Montage, Voice-over, Motion design, Sound design, ...',
      label: 'Audiovisueel',
    },
    '5': {
      description: 'Copywriting, Vertaling, Redactie, ...',
      label: 'Taal en communicatie',
    },
    '6': {
      description: 'IT-development, Web-development, Game-development, ...',
      label: 'IT-ontwikkeling',
    },
    '7': {
      description: 'Cursus, Workshop, ...',
      label: 'Opleiding',
    },
    '8': {
      description: 'Model, Presentator, Acteur, ...',
      label: 'Uitvoerende kunstenaar',
    },
    '9': {
      description: 'Styling, Foodstyling, Interieurontwerp, ...',
      label: 'Styling & interieur',
    },
  },
  add: 'Toevoegen',
  autoSave: 'Opslaan...',
  breadcrumb: 'Breadcrumb',
  autoSaveLastSavedAt: {
    justNow: 'Zojuist opgeslagen',
    timeAgo: '{{timeAgo}} opgeslagen',
  },
  blocker: {
    leave: 'Verlaten zonder opslaan',
    stay: 'Blijf op pagina',
    title: 'Pagina verlaten',
  },
  breadcrumbs: {
    details: 'Details',
    draft: 'Concept',
    home: 'Home',
  },
  languageSelector: 'Open taalkiezer, {{value}} is geselecteerd',
  combobox: {
    removeChip: 'Verwijder {{label}}',
  },
  colorPicker: {
    ariaLabel: 'Verander het kleurenthema. {{ colorTheme }} is actief.',
    options: {
      'blue-orange': 'Blauw-oranje',
      'bordeaux-gray': 'Bordeaux-grijs',
      'green-pink': 'Groen-roze',
      'purple-yellow': 'Paars-geel',
      'red-lightblue': 'Rood-lichtblauw',
    },
  },
  customAgreementOptionLabel: 'Volgens raamovereenkomst',
  datatable: {
    all: 'alles',
    download: 'Download',
    showResults: 'Toon resultaten',
    filters: 'Filters',
    loadingData: 'Gegevens aan het laden...',
    noData: 'Geen resultaten gevonden.',
    search: 'Zoeken',
    selection: {
      amountSelected: '{{amount}} geselecteerd.',
      removeSelection: 'Selectie verwijderen',
      selectAll: 'Alles selecteren',
      selectRow: 'Selecteer rij',
    },
    show: 'Toon',
    showFilters: 'Toon filters',
    deleteFilter: 'Verwijder {{filter}} filter',
    sortBy: 'Sorteer op {{column}}',
  },
  draft: {
    defaultTitle: 'Geen titel',
    deleteModal: {
      description: 'Bent je zeker dat je het concept wilt verwijderen?',
      submit: 'Verwijder concept',
      title: 'Concept verwijderen',
    },
  },
  error: 'Er is iets misgelopen. Stuur het probleem door naar service@creativeshelter.be.',
  errors: {
    contactSupport:
      'Stuur het probleem door naar <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email> als het blijft voorvallen.',
    fetchError: 'De server kan niet bereikt worden. Check je verbinding en probeer het even opnieuw.',
    global: {
      title: 'Er is iets misgelopen',
      text: 'Stuur het probleem door naar <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email>.',
    },
    httpErrorWithLink:
      'Er is iets misgelopen. Stuur het probleem door naar <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email>.',
    tooManyRequests: 'Je probeert dit te vaak. Wacht even en probeer dan opnieuw.',
    unknown: 'Er is een onverwachte fout opgetreden.',
  },
  export: 'Exporteer',
  fields: {
    datePicker: {
      label: 'Datum',
      openCalendar: 'Open kalender',
    },
    numberInput: {
      decrement: 'Waarde verlagen',
      increment: 'Waarde verhogen',
    },
    prefixAriaLabel: 'Dit veld heeft een prefix "{{prefix}}". Je hoeft dit zelf niet meer in te vullen.',
    select: {
      multipleValuesAriaLabel: '{{ count }} items geselecteerd',
    },
    suffixAriaLabel: 'Dit veld heeft een suffix "{{suffix}}". Je hoeft dit zelf niet meer in te vullen.',
  },
  fileUpload: {
    avatarPrompt: '<browse>Klik om een foto te kiezen</browse> of sleep je foto hierin',
    dropTarget: 'Zet je bestanden hier neer',
    error: 'Bestand uploaden mislukt.',
    filePrompt: '<browse>Klik om een bestand te kiezen</browse> of sleep je bestand hierin',
    maxSize: 'max {{max}} MB',
    rejectedSize: '{{name}} is groter dan {{max}} MB.',
    rejectedType: '{{name}} heeft een bestandstype dat niet wordt ondersteund.',
    remove: 'Bestand verwijderen',
    retry: 'Opnieuw proberen',
    unnamedFile: 'Bestand',
    uploading: 'Uploaden',
    view: 'Bestand bekijken',
  },
  greetings: {
    common: 'Hi',
    evening: 'Goedenavond',
    morning: 'Goedemorgen',
    noon: 'Goedemiddag',
  },
  impersonationBanner: {
    description: 'Acties die je hier uitvoert worden geregistreerd alsof deze gebruiker ze zelf doet.',
    stop: 'Stop impersonatie',
    title: 'Je bekijkt het account van {{name}}',
  },
  infiniteScroll: {
    scrollToTop: 'Terug naar boven',
    showMore: 'Meer tonen',
  },
  languages: {
    en: 'Engels',
    fr: 'Frans',
    nl: 'Nederlands',
  },
  languagesShort: {
    en: 'EN',
    fr: 'FR',
    nl: 'NL',
  },
  listbox: {
    noOptions: 'Geen resultaten',
    noResults: 'Geen resultaten',
    search: 'Zoeken...',
  },
  loading: 'Gegevens aan het laden...',
  maintenance: {
    description: 'We zijn even aan het werk in het Craft-platform, maar zijn snel terug zodat je ons niet te lang hoeft te missen.',
    title: 'Heel even weg, maar snel terug!',
  },
  models: {
    quotation: 'Offerte',
  },
  ok: 'Ok',
  optionalInput: '(optioneel)',
  or: 'of',
  pdfPreview: {
    fallback: 'Je browser kan deze PDF niet weergeven.',
    download: 'Download de PDF',
  },
  placeholders: {
    file: 'Kies je bestand',
    select: 'Selecteer...',
  },
  richText: {
    errors: {
      render: 'Er liep iets mis bij het laden van de inhoud.',
    },
    linkModal: {
      editTitle: 'Pas de link aan',
      label: 'Link',
      textLabel: 'Tekst',
      title: 'Vul een link in',
    },
    toolbar: {
      bold: 'Vet',
      bulletList: 'Opsommingslijst',
      editLink: 'Link aanpassen',
      groups: {
        formatting: 'Tekstopmaak',
        history: 'Geschiedenis',
        lists: 'Opsommingen',
        shortcodes: 'Shortcode toevoegen',
      },
      italic: 'Cursief',
      link: 'Link toevoegen',
      orderedList: 'Genummerde lijst',
      redo: 'Opnieuw uitvoeren',
      shortcodes: 'Shortcode toevoegen',
      underline: 'Onderstrepen',
      undo: 'Ongedaan maken',
      unlink: 'Link verwijderen',
    },
  },
  save: 'Opslaan',
  saved: 'Opgeslagen',
  send: 'Verzenden',
  sidebar: {
    clients: 'Klanten',
    community: 'Netwerk',
    dashboard: 'Dashboard',
    forum: 'Forum',
    groupInvoicing: 'Facturatie',
    groupSocial: 'Community',
    invoices: 'Facturen',
    jobPosts: 'Opdrachten',
    expandMenu: 'Menu uitklappen',
    products: 'Producten',
    quotations: 'Offertes',
    help: 'Help',
    minimalizeMenu: 'Menu inklappen',
    invite: 'Vrienden uitnodigen',
    more: 'Meer',
  },
  menu: {
    invitations: 'Uitnodigingen',
    documents: 'Documenten',
    pricing: 'Jouw vergoeding',
    settings: 'Instellingen',
    logout: 'Uitloggen',
  },
  status: {
    completed: 'Voltooid',
    upcoming: 'Nog te doen',
  },
  timeline: {
    ariaLabel: 'Tijdslijn',
  },
  topbar: {
    activePremiumForFree_one: 'Laatste dag gratis factureren',
    activePremiumForFree_other: 'Nog {{count}} dagen gratis factureren',
    dropdown: {
      logout: 'Uitloggen',
      invitations: 'Uitnodigingen',
      documents: 'Documenten',
      commission: 'Jouw vergoeding',
      settings: 'Instellingen',
    },
  },
};
